import { createSlice } from '@reduxjs/toolkit';
import { createAsyncAction } from '../action';
import { Status } from './index';

const getFilteredScheduleCheckups = createAsyncAction('getFilteredScheduleCheckups', 'getFilteredScheduleCheckups');
const getAllScheduleCheckup = createAsyncAction('getAllScheduleCheckup', 'getAllScheduleCheckup');
const downloadScheduleCheckupExcel = createAsyncAction('downloadScheduleCheckupExcel', 'downloadScheduleCheckupExcel');
const updateScheduleCheckupStatus = createAsyncAction('updateScheduleCheckupStatus', 'updateScheduleCheckupStatus');

interface IInitialState {
  isFetchingScheduleCheckup: boolean;
  isFetchingFilteredScheduleCheckups: boolean;
  isUpdatingScheduleCheckup: boolean;
  fetchingScheduleCheckupError: string;
  totalScheduleCheckups: number;
  totalPages: number;
  scheduleCheckupsPerPage: number;
  scheduleCheckups: any;
  scheduleCheckupUpdatingStatus: string;
  scheduleCheckupExcelDownloadLink: string;
  scheduleCheckupExcelDownloadStatus: string;
}

const initialState: IInitialState = {
  isFetchingScheduleCheckup: false,
  isFetchingFilteredScheduleCheckups: false,
  isUpdatingScheduleCheckup: false,
  totalScheduleCheckups: 0,
  totalPages: 1,
  scheduleCheckupsPerPage: 20,
  scheduleCheckups: [],
  scheduleCheckupUpdatingStatus: '',
  fetchingScheduleCheckupError: '',
  scheduleCheckupExcelDownloadLink: '',
  scheduleCheckupExcelDownloadStatus: '',
};

export const counterSlice = createSlice({
  name: 'scheduleCheckup',
  initialState,
  reducers: {
    updateScheduleCheckupState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getFilteredScheduleCheckups.pending as any]: (state) => {
      state.isFetchingFilteredScheduleCheckups = true;
    },
    [getFilteredScheduleCheckups.fulfilled as any]: (state, { payload }) => {
      const { data = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingFilteredScheduleCheckups = false;
      state.scheduleCheckups = data || [];
      state.totalScheduleCheckups = total || state.scheduleCheckups?.length;
      state.scheduleCheckupsPerPage = page_number === 1 ? data?.length : state.scheduleCheckupsPerPage;
      state.totalPages = total_pages || 1;
    },
    [getFilteredScheduleCheckups.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingFilteredScheduleCheckups = false;
      }
    },

    [downloadScheduleCheckupExcel.pending as any]: (state) => {
      state.scheduleCheckupExcelDownloadLink = '';
      state.scheduleCheckupExcelDownloadStatus = Status.pending;
    },
    [downloadScheduleCheckupExcel.fulfilled as any]: (state, { payload }) => {
      state.scheduleCheckupExcelDownloadLink = window.URL.createObjectURL(new Blob([payload], { type: 'application/csv' }));
      state.scheduleCheckupExcelDownloadStatus = Status.fulfilled;
    },
    [downloadScheduleCheckupExcel.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.scheduleCheckupExcelDownloadLink = '';
        state.scheduleCheckupExcelDownloadStatus = Status.rejected;
      }
    },

    [getAllScheduleCheckup.pending as any]: (state) => {
      state.isFetchingScheduleCheckup = true;
    },
    [getAllScheduleCheckup.fulfilled as any]: (state, { payload }) => {
      const { data = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingScheduleCheckup = false;
      state.scheduleCheckups = data || [];
      state.totalScheduleCheckups = total;
      state.scheduleCheckupsPerPage = page_number === 1 ? data?.length : state.scheduleCheckupsPerPage;
      state.totalPages = total_pages;
    },
    [getAllScheduleCheckup.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingScheduleCheckup = false;
      }
    },

    [updateScheduleCheckupStatus.pending as any]: (state) => {
      state.isUpdatingScheduleCheckup = true;
      state.scheduleCheckupUpdatingStatus = Status.pending;
    },
    [updateScheduleCheckupStatus.fulfilled as any]: (state) => {
      state.isUpdatingScheduleCheckup = false;
      state.scheduleCheckupUpdatingStatus = Status.fulfilled;
    },
    [updateScheduleCheckupStatus.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isUpdatingScheduleCheckup = false;
        state.scheduleCheckupUpdatingStatus = Status.rejected;
      }
    },
  },
});

const { updateScheduleCheckupState } = counterSlice.actions;
export {
  updateScheduleCheckupState,
  getFilteredScheduleCheckups,
  getAllScheduleCheckup,
  downloadScheduleCheckupExcel,
  updateScheduleCheckupStatus,
};
export default counterSlice.reducer;
